<template src="./template.html"/>
<style scoped src="./stylesheet.scss" lang="scss"/>

<script>
    import { store } from '../../store/store'

    export default {
        name: "Login",
        data() {
            return {
                form: {
                    email: '',
                    password: ''
                },
            }
        },
        mounted() {

        },
        computed: {
          credentialsError() {
              return store.getters.errorOccurred;
          }
        },
        methods: {
            sign() {
                store.dispatch('login', {
                   email: this.form.email,
                   password: this.form.password
                });
            },
            credentialErrorOkButton() {
                store.commit('clearError');
            }
        }
    }
</script>
